import VueNotify from "@/components/common/cathay-notifikation/notify.vue";

export default {
  install(Vue, options = {}) {
    // Create component instance
    const Constr = Vue.extend(VueNotify);
    const Notify = new Constr();

    // Apply configuration
    Notify.options = Object.assign(Notify.options, options);

    // Mount it
    const vm = Notify.$mount();

    // Add it to the Vue application
    document.querySelector("body").appendChild(vm.$el);

    // Create generic method
    Vue.prototype.$notify = (msg, type = "info", userOptions = {}) => {
      Notify.addItem(type, msg, userOptions);
    };
    Vue.prototype.$notify.info = (msg, userOptions = {}) => {
      Notify.addItem("info", msg, userOptions);
    };
    Vue.prototype.$notify.success = (msg, userOptions = {}) => {
      Notify.addItem("success", msg, userOptions);
    };
    Vue.prototype.$notify.danger = (msg, userOptions = {}) => {
      Notify.addItem("error", msg, userOptions);
    };
    Vue.prototype.$notify.warning = (msg, userOptions = {}) => {
      Notify.addItem("warning", msg, userOptions);
    };
    // Create setTypes method
    Vue.prototype.$notify.setTypes = types => {
      Notify.setTypes(types);
    };
    Vue.prototype.$notify.removeAll = () => {
      Notify.removeAll();
    };

    Vue.prototype.$notify.error = Vue.prototype.$notify.danger;
    Vue.$notify = Vue.prototype.$notify;
  }
};
